/**
 * @file: The words the operator reads for an interval's role.
 *
 * The server sends the role as a key and never sends the priority number. This
 * file turns a key into the word on screen.
 *
 * Two components need the same words: the calendar's bar tooltip and the scene
 * page's interval list. Two copies drifted apart once already, and a rename of
 * one word then reached only one of the two surfaces.
 */

/**
 * The role keys the server knows. A caller that creates an interval sends one
 * of these. The keys are here beside the words, so a caller reads the key from
 * one place and never types the string.
 */
const ROLES = Object.freeze({
  basis: 'basis',
  takeover: 'takeover',
  override: 'override'
})

const ROLE_LABELS = Object.freeze({
  basis: 'Base',
  takeover: 'Takeover',
  override: 'Play now'
})

/**
 * The word for a role key.
 *
 * @param {string} role - A key the server sent, or null for a value that is
 *   older than the roles
 * @returns {string|null} The word, or null when the role is unknown
 */
function labelForRole (role) {
  return ROLE_LABELS[role] || null
}

export { ROLES, ROLE_LABELS, labelForRole }
